import client from './api-client';

export const getConfiguracionForm23 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form23: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGestionImplicado = async(query) => {
    try {
        
        const response = await client.get(`gestion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestionImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboGestionAnalista = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const postProcesar = async(file) => {
    try {
        
        const response = await client.post('caso/cerrar', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaProcesar: response.data};
        } else {
            return {respuestaProcesar: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const getMontosInformados= async(query) => {
    try {
        
        const response = await client.get(`recobro/montos?q=${query}`);        
        if (response.status === 200 && response.data.code === 1) {
            return {
                montosInformados: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}